import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";

export default function HomeAlumni() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const el = galleryRef.current;
      if (!el || inView) return;

      const rect = el.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (isVisible) {
        timeoutRef.current = setTimeout(() => {
          setInView(true);
        }, 500); // add delay
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutRef.current); 
    };
  }, [inView]);



    const sliderRef = useRef(null);
    const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
      {
        breakpoint: 767,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 1 },
      },
    ],
    };

    const CustomArrows = () => (
    <>
      <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
          <Icons name="arrowLeft"/>
      </div>
      <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
          <Icons name="arrowRight"/>
      </div>
    </>
    );

  return (
    <>
    <div className="home-alumni">
        <div className="container">
            <div className="row">  

                <div className="col-lg-11">
                    <div className="alumni-head">
                        <span>Choose an Inspiration</span>
                        <h4 className="heading">A Glimpse into the Journey and Impact of Our Proud Alumni</h4>
                        <p>Every student carries a dream, and every dream needs a spark. At Lucknow Public School, we believe in learning from those who have walked the path before us.</p>
                    </div>
                </div>

                <div className="col-lg-12 mobileview-slider">
                    <Slider {...settings} ref={sliderRef}> 
                        <div className="student-box">
                            <Link>
                                <img src="/image/student-2.webp" className="img-responsive" alt="student" loading="lazy"/>
                                <div>
                                    <p>Ruchi Chaturvedi</p>
                                    <span>Batch 2003 (Sector-I)</span>
                                </div>
                            </Link>
                        </div>

                        <div className="student-box">
                            <Link>
                                <img src="/image/student-3.webp" className="img-responsive" alt="student" loading="lazy"/>
                                <div>
                                    <p>Vishwanath Pratap Singh</p>
                                    <span>Batch 2012 (Sector-I)</span>
                                </div>
                            </Link>
                        </div>

                        <div className="student-box">
                            <Link>
                                <img src="/image/student-4.webp" className="img-responsive" alt="student" loading="lazy"/>
                                <div>
                                    <p>Priya Barranwal</p>
                                    <span>Batch 2012 (Sector-I)</span>
                                </div>
                            </Link>
                        </div>

                        <div className="student-box">
                            <Link>
                                <img src="/image/student-1.webp" className="img-responsive" alt="student" loading="lazy"/>
                                <div>
                                    <p>Abhishek Pratap</p>
                                    <span>Batch 2015 (Ahiyaraipur)</span>
                                </div>
                            </Link>
                        </div>
                    </Slider>
                    <CustomArrows />
                </div>

            </div>
        </div>

        <div ref={galleryRef} className={`hidefor-slider student-grid ${inView ? "showstudent" : ""}`}>
            <div className="student-box">
                <Link>
                    <img src="/image/student-2.webp" className="img-responsive" alt="student" loading="lazy"/>
                    <div>
                        <p>Ruchi Chaturvedi</p>
                        <span>Batch 2003 (Sector-I)</span>
                    </div>
                </Link>
            </div>

            <div className="student-box">
                <Link>
                    <img src="/image/student-3.webp" className="img-responsive" alt="student" loading="lazy"/>
                    <div>
                        <p>Vishwanath Pratap Singh</p>
                        <span>Batch 2012 (Sector-I)</span>
                    </div>
                </Link>
            </div>

            <div className="student-box">
                <Link>
                    <img src="/image/student-4.webp" className="img-responsive" alt="student" loading="lazy"/>
                    <div>
                        <p>Priya Barranwal</p>
                        <span>Batch 2012 (Sector-I)</span>
                    </div>
                </Link>
            </div>

            <div className="student-box">
                <Link>
                    <img src="/image/student-1.webp" className="img-responsive" alt="student" loading="lazy"/>
                    <div>
                        <p>Abhishek Pratap</p>
                        <span>Batch 2015 (Ahiyaraipur)</span>
                    </div>
                </Link>
            </div>
        </div>

    </div>
    </>
  )
}
